export const newWebsite = [
  {
    title: 'pages.newWebsite.content.welcomeTitle',
    content: 'pages.newWebsite.content.welcomeSection',
  },
  {
    title: 'pages.newWebsite.content.passwordTitle',
    content: 'pages.newWebsite.content.passwordSection',
  },
  {
    title: 'pages.newWebsite.content.ipTitle',
    content: 'pages.newWebsite.content.ipSection',
  },
  {
    title: 'pages.newWebsite.content.ownerTitle',
    content: 'pages.newWebsite.content.ownerSection',
  },
  {
    title: 'pages.newWebsite.content.seneTitle',
    content: 'pages.newWebsite.content.seneSection',
  },
]
